import React from 'react';
import './Review.scss';

import reviewsImage1 from './assets/Prop1.png';
import reviewsImage2 from './assets/Prop2.png';

const ReviewDisplay = () => {
  return (
    <div className="review-container">
      <img src={reviewsImage1} alt="Your Move" className="review-image" loading="lazy" />
      <img src={reviewsImage2} alt="Your Move" className="review-image" loading="lazy" />
    </div>
  );
};

export default ReviewDisplay;
